import common from "@/scripts/common";
import store from '@/store';

/* eslint no-unused-vars: 'off', no-unreachable: 'off', yoda: 'off', no-prototype-builtins: 'off'  */

// initial state
// shape: [{ id, quantity }]
const initialState = {
    myAnalysis: {
        isLoaded: false,
        height: 0
    },

    myHelp: {
        isLoaded: false,
        setHeight: null,
    },

    crosstabTitle: {     //This is here just to tell the resize code there is no title
        isLoaded: false
    },

    //Methods: getLeftMarginToRightJustify
    singleCrosstab: {
        isLoaded: false,
        crosstabWrapper: null,
        outerCrosstabWrapper: null,
        usableDisplayArea: null,
        hasChiSquare: null
    },

    crosstabTable: {
        isLoaded: false,
        width: 0
    },

    chiSquare: {
        isLoaded: false,
        subTable: null,
    },

    datasetTotals: {
        isLoaded: false,
        subTable: null,
    },

    footnotes: {
        isLoaded: false,
        subTable: null,
    },

    levelCounts: [1, 1],
    totalReports: -1,
    allLoaded: false

}

const initialSubState = {
    crosstabTitle: {     //There is only a crosstabTitle sub crosstab
        isLoaded: false,
        subTable: null,
    },

    chiSquare: {
        isLoaded: false,
        subTable: null,
    },

    singleCrosstab: {
        isLoaded: false,
        crosstabWrapper: null,
        outerCrosstabWrapper: null,
        hasChiSquare: null
    },

    crosstabTable: {
        isLoaded: false,
        width: 0,
        setColumnWidths: null
    },

    footnotes: {
        isLoaded: false,
        subTable: null,
    }
}



const state = initialState;
//state['k_3_0'] = initialSubState;
const allControls = ['myAnalysis', 'myHelp'];
const allCtControls = ['singleCrosstab', 'crosstabTable', 'footnotes', 'datasetTotals'];
const allSubCtControls = ['singleCrosstab', 'crosstabTable', 'footnotes', 'crosstabTitle'];

// getters
const getters = {
}


function anyMissingSubCt(r) {

    for (let i = 0; i < r.levelCounts[0]; ++i) {
        for (let j = 0; j < r.levelCounts[1]; ++j) {
            const isMasterCT = i === 0 && j === 0;
            if (!isMasterCT) {
                const ctKey = common.getCtKey(i, j);
                let controlMissing = common.forFirst(
                    allSubCtControls,
                    (c) => !r[ctKey] || !r[ctKey][c] || !r[ctKey][c].isLoaded,
                    (c, ci) => logMissingSubControl(r, c, ci, ctKey, i, j)
                );
                if (controlMissing) return true;
                if (chiSquareNeededAndMissing(r[ctKey], ctKey))
                    return true;

            }
        }
    }
    return false;

    // let controlMissing = common.forFirst(
    //     allControls,
    //     (c) => !r[c].isLoaded
    // );
}

function anyMissingControl() {
    const r = store.state.loadedControls;

    let controlMissing = common.forFirst(
        allControls,
        (c) => !r[c] || !r[c].isLoaded,
        (c, i) => logMissingControl(`Standard Control Missing ${c}`)
    );
    if (controlMissing)
        return true;

    //Get root controls
    controlMissing = common.forFirst(
        allCtControls,
        (c) => !r[c] || !r[c].isLoaded,
        (c, i) => logMissingControl(`Ct Control Missing ${c}`)
    );
    if (controlMissing)
        return true;
    if (chiSquareNeededAndMissing(r))
        return true;

    return anyMissingSubCt(r);
}

let lastMissingControlMessage = null;
let missingMessageBounce = null;



function logMissingSubControl(r, c, ci, ctKey, i, j) {
    //if (r[ctKey] && !!r[ctKey][c]  r[ctKey][c].isLoaded)
    lastMissingControlMessage = `Ct Control Missing ${c} for key ${ctKey} [${i},${j}]`;

    if (!missingMessageBounce) missingMessageBounce = _.debounce(writeToConsole, 600);
    missingMessageBounce();

    //console.log(`mounted Ct Control Missing ${c} for key ${ctKey} [${i},${j}]`, r[ctKey], ctKey, r[ctKey][c], !r[ctKey] || !!r[ctKey][c] || !r[ctKey][c].isLoaded)
}

function logMissingControl(theMessage) {
    lastMissingControlMessage = theMessage;
    if (!missingMessageBounce) missingMessageBounce = _.debounce(writeToConsole, 600);
    missingMessageBounce();
}

function writeToConsole() {
    // if (!lastMissingControlMessage)
    //     console.log('loadedControls: ' + lastMissingControlMessage);
}

function chiSquareNeededAndMissing(r) {
    const isMissing = r.singleCrosstab.hasChiSquare && !r.chiSquare.isLoaded;
    if (isMissing)
        logMissingControl(`chiSquare is missing for key ${ctKey}`);
    return isMissing;
}

// actions
const actions = {
    startReport({ commit, state }, { levelCounts }) {
        lastMissingControlMessage = null;
        missingMessageBounce = null;
        let totalReports = levelCounts[0] * levelCounts[1];
        commit('startReport', { levelCounts, totalReports });
    },
    mounted({ commit, state }, { name, id, control1, control2, height, width, crosstabWrapper, outerCrosstabWrapper, usableDisplayArea, hasChiSquare, subTable, setHeight, setColumnWidths }) {
        const ctKey = common.getCtKeyFromControls(control1, control2);

        commit('controlMounted', { name, id, height, width, ctKey, crosstabWrapper, outerCrosstabWrapper, usableDisplayArea, hasChiSquare, subTable, setHeight, setColumnWidths });
        if (!anyMissingControl()) {
            lastMissingControlMessage = null;
            commit('allControlsAreLoaded');
        }
    }

}

function removeOldLevels(state, oldLevelCounts) {
    if (oldLevelCounts && oldLevelCounts.length === 2) {
        for (let i = 0; i < oldLevelCounts[0]; ++i) {
            for (let j = 0; j < oldLevelCounts[1]; ++j) {
                const isMasterCT = i === 0 && j === 0;
                if (!isMasterCT) {
                    const ctKey = common.getCtKey(i, j);
                    state[ctKey] = null;
                    deleteDeep(state, ctKey); //[Vue warn]: Avoid deleting properties on a Vue instance or its root $data - just set it to null.
                }
            }
        }
    }
}
// mutations
const mutations = {
    startReport(state, { levelCounts, totalReports }) {

        removeOldLevels(state, state.levelCounts)
        state = initialState;
        //state['k_3_0'] = initialSubState;
        state.levelCounts = levelCounts;
        state.totalReports = totalReports;
    },
    controlMounted(state, { name, id, ctKey, height, width, crosstabWrapper, outerCrosstabWrapper, usableDisplayArea, hasChiSquare, subTable, setHeight, setColumnWidths }) {

        //https://stackoverflow.com/questions/54811786/vuex-and-dynamic-states-is-possible
        //vueSet(state.data, key, value)
        if (ctKey && !state[ctKey]) {
            setDeep(state, ctKey, initialSubState);
            //state[ctKey] = initialSubState;
        }


        const storeLocation = ctKey ? state[ctKey] : state;
        const s = storeLocation[name];

        s.isLoaded = true;

        setValue(s, 'id', id);
        setValue(s, 'height', height);
        setValue(s, 'width', width);
        setValue(s, 'crosstabWrapper', crosstabWrapper);
        setValue(s, 'outerCrosstabWrapper', outerCrosstabWrapper);
        setValue(s, 'usableDisplayArea', usableDisplayArea);
        setValue(s, 'hasChiSquare', hasChiSquare);
        setValue(s, 'subTable', subTable);
        setValue(s, 'setHeight', setHeight);
        setValue(s, 'setColumnWidths', setColumnWidths);


        // if (ctKey && state[ctKey][name])
        //     state[ctKey][name].id = id;
        // //if (s.id || id) s.id = id;
        // if (s.height || height) s.height = height;
        // if (s.width || width) s.width = width;
        // if (s.crosstabWrapper || crosstabWrapper) s.crosstabWrapper = crosstabWrapper;
        // if (s.outerCrosstabWrapper || outerCrosstabWrapper) s.outerCrosstabWrapper = outerCrosstabWrapper;
        // if (s.usableDisplayArea || usableDisplayArea) s.usableDisplayArea = usableDisplayArea;
        // if (s.hasChiSquare || hasChiSquare) s.hasChiSquare = hasChiSquare;
        // if (s.subTable || subTable) s.subTable = subTable;
        // if (s.setHeight || setHeight) s.setHeight = setHeight;
        // if (s.setColumnWidths || setColumnWidths) s.setColumnWidths = setColumnWidths;
    },
    allControlsAreLoaded(state) {
        let triggerResize = !state.allLoaded;
        state.allLoaded = true;
        return triggerResize;
    }
}

function setValue(s, name, value) {
    if (s[name] || value) s[name] = value;
}

function deleteChildren(source, key) {
    let obj = source[key];

    // Handle the 3 simple types, and null or undefined
    if (null == obj || "object" != typeof obj || obj instanceof Date)
        source[key] = null;
    else if (obj instanceof Array)
        source[key] = null;
    else if (obj instanceof Object) {
        for (var attr in obj) {
            if (obj.hasOwnProperty(attr))
                deleteDeep(source[key], attr);
        }
        source[key] = null;
    } else
        source[key] = null;
}

//Changed all Vue.delete to delete, and Vue.set to 
function vueDelete(source, key) {
    delete source[key];
}

function vueSet(destination, key, value) {
    destination[key]=value;
}

function deleteDeep(source, key) {
    let obj = source[key];

    // Handle the 3 simple types, and null or undefined
    if (null == obj || "object" != typeof obj || obj instanceof Date) {
        vueDelete(source, key)
    }
    // Handle Array
    else if (obj instanceof Array) {
        //No deep clone on an array            
        //copy = [];
        // for (var i = 0, len = obj.length; i < len; i++) {
        //     source[key][i] = obj;  
        //     //copy[i] = setDeep(obj[i]);
        // }
        vueDelete(source, key);
    } else if (obj instanceof Object) {
        for (var attr in obj) {
            if (obj.hasOwnProperty(attr))
                deleteDeep(source[key], attr);
        }
        vueDelete(source, key);
    } else
        vueDelete(source, key);
}

function setDeep(destination, key, obj) {
    // Handle the 3 simple types, and null or undefined
    if (null == obj || "object" != typeof obj) {
        vueSet(destination, key, obj)
    } else if (obj instanceof Date) {
        let copy = new Date();
        copy.setTime(obj.getTime());
        vueSet(destination, key, copy)
    } else if (obj instanceof Array) {
        let arrayCopy = [];
        for (var i = 0, len = obj.length; i < len; i++) {
            arrayCopy[i] = obj;  //No deep clone on an array            
        }
        vueSet(destination, key, arrayCopy)
    } else if (obj instanceof Object) {
        vueSet(destination, key, {})
        for (let attr in obj) {
            if (obj.hasOwnProperty(attr))
                setDeep(destination[key], attr, obj[attr])
        }
    } else
        throw new Error("Unable to copy obj! Its type isn't supported.");
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
